import { useState } from "react";
import { strings } from "@/i18n/strings";
import { useSite } from "@/context/SiteContext";
import { BUILT_IN_MENU } from "@/lib/menu";
import { MenuOrder } from "@/components/admin/MenuOrder";

const Label = ({ k, lang, value, onSave }) => {
  const [v, setV] = useState(value);
  return (
    <input
      data-testid={`ve-menu-${k.replace(".", "-")}-${lang}`}
      value={v}
      placeholder={lang === "mh" ? "Marshallese" : "English"}
      onChange={(e) => setV(e.target.value)}
      onBlur={() => v.trim() !== value && onSave(v.trim())}
      onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()}
      className="w-full min-w-0 rounded-lg border border-[#14213D]/15 bg-white px-2.5 py-1.5 font-ui text-sm text-[#14213D] outline-none focus:border-[#C8862F]"
    />
  );
};

// Rename the website menu (English & Marshallese) and change its order.
export const MenuPanel = ({ text = {}, onPatch }) => {
  const { pages } = useSite();
  const items = [["home", "/", "nav.home"], ...BUILT_IN_MENU, ["donate", "/donate", "nav.donate"], ["contact", "/contact", "nav.contact"], ["listen", "", "nav.listen"]]
    .filter(([, , k], i, a) => a.findIndex(([, , k2]) => k2 === k) === i && strings.en[k]);
  const val = (lang, k) => text?.[lang]?.[k] || strings[lang]?.[k] || "";
  return (
    <div className="grid gap-5" data-testid="ve-menu-panel">
      <div>
        <p className="mb-1 font-ui text-[11px] uppercase tracking-widest text-[#8A6A12]">Menu names</p>
        <p className="mb-3 text-xs text-[#4A5568]">Type a new name, then click outside the box. It saves as a draft; press PUBLISH to make it live. You can also click a menu word right in the preview.</p>
        <div className="grid gap-2">
          {items.map(([, , k]) => (
            <div key={`${k}-${val("en", k)}-${val("mh", k)}`} className="grid grid-cols-2 gap-2">
              <Label k={k} lang="en" value={val("en", k)} onSave={(v) => onPatch({ text: { en: { [k]: v } } })} />
              <Label k={k} lang="mh" value={val("mh", k)} onSave={(v) => onPatch({ text: { mh: { [k]: v } } })} />
            </div>
          ))}
        </div>
        {(pages || []).length > 0 && <p className="mt-2 text-[11px] text-[#5F6875]">Custom page names are changed in the Pages tab.</p>}
      </div>
      <div>
        <p className="mb-1 font-ui text-[11px] uppercase tracking-widest text-[#8A6A12]">Menu order</p>
        <p className="mb-2 text-xs text-[#4A5568]">Drag to reorder. The order saves to the live website right away.</p>
        <MenuOrder />
      </div>
    </div>
  );
};
